(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  if (!customElements.get('load-more-products')) {
    class LoadMoreProducts extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.button = this.querySelector('[data-load-more-button]');
        this.status = this.querySelector('[data-load-more-status]');
        this.announcement = this.querySelector('[data-load-more-announcement]');

        if (!this.button) return;

        this.dataset.initialized = 'true';
        this.button.addEventListener('click', this.handleClick.bind(this));
      }

      async handleClick(event) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        if (this.loading) {
          event.preventDefault();
          return;
        }

        const nextPageUrl = this.button.getAttribute('href');
        if (!nextPageUrl) return;

        event.preventDefault();
        this.setLoading(true);

        try {
          const requestUrl = new URL(nextPageUrl, window.location.origin);
          requestUrl.searchParams.set('section_id', this.dataset.sectionId);

          const response = await fetch(requestUrl.toString(), {
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
            },
          });

          if (!response.ok) throw new Error(`Unable to load products: ${response.status}`);

          const html = await response.text();
          const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
          const nextGrid = parsedDocument.getElementById('product-grid');
          const currentGrid = document.getElementById('product-grid');
          const nextControl = parsedDocument.querySelector('load-more-products');

          if (!nextGrid || !currentGrid || !nextControl) {
            throw new Error('The next product page could not be read.');
          }

          const newItems = Array.from(nextGrid.children);
          if (newItems.length === 0) throw new Error('The next product page was empty.');

          currentGrid.append(...newItems);

          const nextStatus = nextControl.querySelector('[data-load-more-status]');
          if (this.status && nextStatus) {
            this.status.textContent = nextStatus.textContent.trim();
          }

          if (this.announcement) {
            this.announcement.textContent = nextControl.dataset.loadedMessage || '';
          }

          const nextButton = nextControl.querySelector('[data-load-more-button]');
          if (nextButton) {
            this.button.setAttribute('href', nextButton.getAttribute('href'));
          } else {
            this.button.remove();
            this.button = null;
          }
        } catch (error) {
          window.location.assign(nextPageUrl);
        } finally {
          if (this.button) this.setLoading(false);
        }
      }

      setLoading(isLoading) {
        this.loading = isLoading;
        this.toggleAttribute('aria-busy', isLoading);
        this.button.classList.toggle('loading', isLoading);
        this.button.toggleAttribute('aria-disabled', isLoading);
        this.button
          .querySelector('.loading__spinner')
          ?.classList.toggle('hidden', !isLoading);

        if (isLoading) {
          this.button.setAttribute('aria-label', this.button.dataset.loadingLabel);
        } else {
          this.button.removeAttribute('aria-label');
        }
      }
    }

    customElements.define('load-more-products', LoadMoreProducts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smokey-product-studies"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('smokey-home-load-more')) {
    class SmokeyHomeLoadMore extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.button = this.querySelector('[data-load-more-button]');
        this.status = this.querySelector('[data-load-more-status]');
        this.announcement = this.querySelector('[data-load-more-announcement]');

        if (!this.button) return;

        this.dataset.initialized = 'true';
        this.button.addEventListener('click', this.handleClick.bind(this));
      }

      async handleClick(event) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        if (this.loading) {
          event.preventDefault();
          return;
        }

        const nextPageUrl = this.button.getAttribute('href');
        if (!nextPageUrl) return;

        event.preventDefault();
        this.setLoading(true);

        try {
          const requestUrl = new URL(nextPageUrl, window.location.origin);
          requestUrl.hash = '';
          requestUrl.searchParams.set('section_id', this.dataset.sectionId);

          const response = await fetch(requestUrl.toString(), {
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
            },
          });

          if (!response.ok) throw new Error(`Unable to load products: ${response.status}`);

          const html = await response.text();
          const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
          const nextGrid = parsedDocument.getElementById(this.dataset.gridId);
          const currentGrid = document.getElementById(this.dataset.gridId);
          const nextControl = nextGrid?.querySelector('smokey-home-load-more');

          if (!nextGrid || !currentGrid || !nextControl) {
            throw new Error('The next homepage product set could not be read.');
          }

          const newItems = Array.from(nextGrid.children).filter((item) =>
            item.classList.contains('smokey-product-card'),
          );
          if (newItems.length === 0) throw new Error('The next homepage product set was empty.');

          newItems.forEach((item) => currentGrid.insertBefore(item, this));

          const nextStatus = nextControl.querySelector('[data-load-more-status]');
          if (this.status && nextStatus) {
            this.status.textContent = nextStatus.textContent.trim();
          }

          if (this.announcement) {
            this.announcement.textContent = nextControl.dataset.loadedMessage || '';
          }

          const nextButton = nextControl.querySelector('[data-load-more-button]');
          if (nextButton) {
            this.button.setAttribute('href', nextButton.getAttribute('href'));
          } else {
            this.button.remove();
            this.button = null;
          }
        } catch (error) {
          window.location.assign(nextPageUrl);
        } finally {
          if (this.button) this.setLoading(false);
        }
      }

      setLoading(isLoading) {
        this.loading = isLoading;
        this.toggleAttribute('aria-busy', isLoading);
        this.button.classList.toggle('loading', isLoading);
        this.button.toggleAttribute('aria-disabled', isLoading);
        this.button
          .querySelector('.loading__spinner')
          ?.classList.toggle('hidden', !isLoading);

        if (isLoading) {
          this.button.setAttribute('aria-label', this.button.dataset.loadingLabel);
        } else {
          this.button.removeAttribute('aria-label');
        }
      }
    }

    customElements.define('smokey-home-load-more', SmokeyHomeLoadMore);
  }

  } catch(e) { console.error(e); }
})();
})();
